module.exports = __webpack_public_path__ + "media/images/version_merge/why_coins-9c71d95f1a9ef7b727cf22d80ccd73cf.svg";